module.exports = __webpack_public_path__ + "img/kmap@2x.8ebd7895.png";